import React from 'react';
import Typography from '@material-ui/core/Typography';

const Page404 = () => (
  <Typography variant="h6">
    404 not found
  </Typography>
);

export default Page404;



// WEBPACK FOOTER //
// ./src/pages/Page404.js